export class ElementNotFoundError extends Error {
    static {
        this.prototype.name = 'ElementNotFoundError';
    }
    constructor(selector = 'unknown selector', options = {}) {
        const { additionalMessage, ...rest } = options;
        const message = `Selector didn't match: ${selector}${additionalMessage ? `: ${additionalMessage}` : ''}`;
        super(message, rest);
    }
}
export class NoHTMLElementError extends Error {
    static {
        this.prototype.name = 'NoHTMLElementError';
    }
    constructor(selector = 'unknown selector', options = {}) {
        const { element, ...rest } = options;
        let message = `"${selector}" element is not HTMLElement`;
        if (element) {
            message += `: Its namespace is "${element.namespaceURI}"`;
        }
        super(message, rest);
    }
}
